module.exports = __webpack_public_path__ + "static/media/storyRegister3.52b5e845.png";